import Swiper from "swiper/bundle";

class Slider {
  constructor() {
    // Slider Post servizi correlati
    this.SliderRelatedServiceContainer = document.querySelectorAll(
      ".slider-related-services"
    );

    if (this.SliderRelatedServiceContainer) {
      this.initSliderRelatedService();
    }
    // Slider Post Clinics
    this.SliderClinicsContainer = document.querySelectorAll(".slider-clinics");

    if (this.SliderClinicsContainer) {
      this.initSliderClinics();
    }

    // Slider block gallery
    this.SliderGalleryContainer = document.querySelectorAll(".slider-gallery");

    if (this.SliderGalleryContainer) {
      this.initSliderGallery();
    }

    // Slider Post Teams
    this.SliderTeamsContainer = document.querySelectorAll(".slider-teams");

    if (this.SliderTeamsContainer) {
      this.initSliderTeams();
    }
  }

  initSliderTeams() {
    this.SliderTeamsContainer.forEach((slider) => {
      new Swiper(slider, {
        loop: false,
        spaceBetween: 16,
        slidesPerView: 1,
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: false,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },
        },
      });
    });
  }

  initSliderRelatedService() {
    this.SliderRelatedServiceContainer.forEach((slider) => {
      new Swiper(slider, {
        loop: false,
        spaceBetween: 16,
        slidesPerView: 1,
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: false,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      });
    });
  }

  initSliderClinics() {
    this.SliderClinicsContainer.forEach((slider) => {
      new Swiper(slider, {
        loop: false,
        spaceBetween: 16,
        slidesPerView: 1,
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: false,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      });
    });
  }

  initSliderGallery() {
    this.SliderGalleryContainer.forEach((slider) => {
      new Swiper(slider, {
        loop: true,
        spaceBetween: 20,
        slidesPerView: 1.2,
        keyboard: {
          enabled: true,
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        speed: 1000,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: false,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      });
    });
  }
}

export default Slider;
